import { render, staticRenderFns } from "./Morbidity.vue?vue&type=template&id=4370cb39&"
import script from "./Morbidity.vue?vue&type=script&lang=js&"
export * from "./Morbidity.vue?vue&type=script&lang=js&"
import style0 from "./Morbidity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports